import { UserInfo } from './user-info';
import { OriginInfo } from './origin-info';
import { AttendanceConfiguration } from './attendance-configuration';

export class LoginInfo {
  constructor(
    public readonly user: UserInfo,
    public readonly origins: OriginInfo[],
    public readonly token: string,
    public readonly attendanceConfiguration: AttendanceConfiguration
  ) {}
}
